// eslint-disable-next-line
// @ts-nocheck
import { filter, toUpper } from 'lodash';
import { useEffect, useState } from 'react';
import { Link as RouterLink, useNavigate , useLocation} from 'react-router-dom';
// material
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import {
  Card,
  Table,
  Stack,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  IconButton,
  Collapse,
  TableHead,
  Modal,
  Select,
  Tooltip,
  MenuItem,
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
// components
import Page from '../../components/Page';
import Scrollbar from '../../components/Scrollbar';
import SearchNotFound from '../../components/SearchNotFound';
import { BookingListHead, BookingListToolbar, BookingMoreMenu } from '../../sections/@dashboard/bookings';
import { getbookingSpaces, getBookingTotalRecords, setBookings } from '../../store/state/bookingSlice';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import {
  useGetAllBookingDetailBySearchCriteriaMutation,
  useUpdateBookingDetailMutation,
} from '../../store/api/bookingsApi';
import { fDateTimeSuffix } from '../../utils/formatTime';
import Loading from '../../components/Loading';
import '../../components/Style.css';
import { checkPermissions, getUniqueKey, roundNumber } from '../../sections/@dashboard/parkingspaces/utility';
import { PERMISSION } from '../../utils/userPermission';
import { formatTime, timeInMiliseconds } from '../../sections/@dashboard/parkingspaces/utility';
import toast from 'react-hot-toast';
import { setISODay } from 'date-fns';
import ClearIcon from '@mui/icons-material/Clear';
import { useGetCheckInDetailsMutation } from '../../store/api/subBookingApi';
import { Formik } from 'formik';
import PersonAddIcon from '@mui/icons-material/PersonAdd';


// ___________________________________
import { useCheckStatusMutation, useStartPaymentMutation } from '../../store/api/posApi';
import { useGetAllDeviceDataMutation } from '../../store/api/posDeviceApi';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'bookingCode', label: 'Booking Code', alignRight: false },
  { id: 'name', label: 'Customer Name', alignRight: false },
  { id: 'vendorName', label: 'Vendor Name', alignRight: false },
  // { id: 'parkingSpaceName', label: 'Parking Space Name', alignRight: false },
  { id: 'amount', label: 'Booking Amount', alignRight: false },
  // { id: 'parkingCategory', label: 'Parking Category', alignRight: false },
  { id: 'bookingDate', label: 'Booking Date', alignRight: false },
  { id: 'pickupDate', label: 'Pickup Date', alignRight: false },
  { id: 'dropoffDate', label: 'Dropoff Date', alignRight: false },
  { id: 'pickupAddress', label: 'Pickup Address', alignRight: false },
  { id: 'dropoffAddress', label: 'Dropoff Address', alignRight: false },
  // { id: 'timer', label: 'Duration', alignRight: false },
  // pos code start
  // { id: 'action', label: 'Action', alignRight: false },
  // pos code end
  { id: 'status', label: 'Booking Status', alignRight: false },
  //{ id: 'addDriver', label: 'Add Driver', alignRight: false },
];

const TABLE_HEAD_CANCELBOOKING = [
  { id: 'bookingCode', label: 'Booking Code', alignRight: false },
  { id: 'name', label: 'Customer Name', alignRight: false },
  { id: 'vendorName', label: 'Vendor Name', alignRight: false },
  // { id: 'parkingSpaceName', label: 'Parking Space Name', alignRight: false },
  { id: 'amount', label: 'Booking Amount', alignRight: false },
  { id: 'bookingDate', label: 'Booking Date', alignRight: false },
  { id: 'status', label: 'Booking Status', alignRight: false },
  { id: 'cancelReasons', label: 'Cancellation Reason', alignRight: false },
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

let flag = ['CURRENT_BOOKING', 'PAST_BOOKING', 'CANCEL_BOOKING'];

export default function AllBookings() {
  const location = useLocation();
  console.log("Received location state:", location.state);
  const navigate = useNavigate();
  const bookingSpacesData = useAppSelector(getbookingSpaces);
  const bookingTotalRecords = useAppSelector(getBookingTotalRecords);
  const token = JSON.parse(localStorage.getItem('login')) || null;
  const [bookingSpaces, setbookingSpaces] = useState([]);
  const [getAllBookingDetailBySearchCriteria, getAllBookingResponse] = useGetAllBookingDetailBySearchCriteriaMutation();
  const [getAllCancellation, getAllCancellationResponse] = useGetAllBookingDetailBySearchCriteriaMutation();
  const [getAllDeviceData, getAllDeviceDataResponse] = useGetAllDeviceDataMutation();
  const dispatch = useAppDispatch();
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('id');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [value, setValue] = useState(0);
  //const [getFlag, setFlag] = useState(flag[0]);
  const [getFlag, setFlag] = useState<string>(flag[0]); // Default to "CURRENT_BOOKING"

  useEffect(() => {
    console.log("Checking location state in useEffect:", location.state);
    
    if (location.state?.flag && flag.includes(location.state.flag)) {
      console.log("Updating getFlag to:", location.state.flag);
      setFlag(location.state.flag);
    }
  }, [location.state]); 
  const [customerName, setcustomerName] = useState('');
  const [cancelRequestCount, setCancelRequestCount] = useState(0);
  const [open, setOpen] = useState(false);
  const [opens, setOpens] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [valueID, setValueID] = useState();
  const [getCheckInDetails, getCheckInDetailsResponse] = useGetCheckInDetailsMutation();
  const [subBooking, setSubBooking] = useState([]);
  const [startPayment, startPaymentResponse] = useStartPaymentMutation();
  const [checkStatus, checkStatusResponse] = useCheckStatusMutation();
  console.log('checkStatusResponse', checkStatusResponse);
  const [updateBookingDetail, updateBookingDetailResponse] = useUpdateBookingDetailMutation();
  const [rowData, setRowData] = useState();
  const filteredUsers = bookingSpaces;
  const isUserNotFound = filteredUsers.length === 0;
  const checkInStatusStyle = { color: '#f57f10' };
  const completedStatusStyle = { color: '#217208' };
  const checkoutStatusStyle = { color: 'red' };
  const [messageCode, setMessageCode] = useState();
  const [id, setId] = useState() as any;
  const [traxnId, setTraxnId] = useState() as any;
  const [posDeviceData, setPosDeviceData] = useState([]) as any;
  console.log(posDeviceData, "posDeviceData");


  const [initialValues, setInitialValues] = useState({
    posDevice: ''
  });

  const validate = (values: any) => {
    console.log(values)
    const errors: any = {};

    if (!values.posDevice) errors['posDevice'] = 'This field is required';
    return errors;
  };

  const styleActiveModel = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: '10px',
    p: '40px',
    px: '30px',
  };

  const handleOpen = (id: any) => {
    setOpen(true);
    getCheckInDetails({
      id: id,
      token: token.token,
    });
  };
  const handleClose = () => setOpen(false);


  const handleOpenModal = (id: any) => {
    console.log(id, id);
    setOpenModal(true);
    getAllDeviceData({
      token: token.token,
      payload: {
        offset: 100,
        page: 0,
        parkingLocationId: id,
        status: true,
      },
    });

  };
  const handleCloseModal = () => setOpenModal(false);


  useEffect(() => {
    if (getAllDeviceDataResponse.isSuccess) {
      setPosDeviceData(getAllDeviceDataResponse.data.data);
    }
    if (getAllDeviceDataResponse.isError) {
      let errorData: any = getAllDeviceDataResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;
      toast.error('Something went wrong ' + msg || '');
    }
  }, [getAllDeviceDataResponse.isSuccess, getAllDeviceDataResponse.isError]);


  useEffect(() => {
    if (bookingSpacesData) {
      setbookingSpaces(bookingSpacesData);
    }
  }, [bookingSpacesData]);

  useEffect(() => {
    if (token) {
      getAllBookingDetailBySearchCriteria({
        token: token.token,
        payload: {
          offset: rowsPerPage,
          page: page,
          orderBy: order,
          columnName: orderBy,
          flag: flag[0],
          customerName: customerName,
        },
      });
    }
    setFilterName('');
    setValue(0);
  }, []);

  useEffect(() => {
    if (getCheckInDetailsResponse.isSuccess) {
      setSubBooking(getCheckInDetailsResponse.data);
    }
  }, [getCheckInDetailsResponse.isSuccess]);

  useEffect(() => {
    if (getAllBookingResponse.isSuccess) {
      dispatch(setBookings(getAllBookingResponse.data));
    }
    if (getAllBookingResponse.isError) {
      let errorData: any = getAllBookingResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;
      toast.error('Something went wrong ' + msg || '');
    }
  }, [getAllBookingResponse.isSuccess, getAllBookingResponse.isError]);

  useEffect(() => {
    if (token) {
      getAllCancellation({
        token: token.token,
        payload: {
          offset: rowsPerPage,
          page: page,
          orderBy: order,
          columnName: orderBy,
          flag: 'CANCEL_REVIEW_BOOKING',
          customerName: customerName,
        },
      });
    }
  }, []);

  useEffect(() => {
    if (getAllCancellationResponse.isSuccess) {
      setCancelRequestCount(getAllCancellationResponse.data?.totalRecords);
    }
    if (getAllCancellationResponse.isError) {
      let errorData: any = getAllCancellationResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;
      toast.error('Something went wrong ' + msg || '');
    }
  }, [getAllCancellationResponse.isSuccess, getAllCancellationResponse.isError]);

  function LinkTab(props) {
    return (
      <Tab
        component="a"
        onClick={(event) => {
          event.preventDefault();
        }}
        {...props}
      />
    );
  }

  const handleSubTable = async (value) => {
    setOpens(!opens);
    setValueID(value);
  };

  const handleChange = async (event, newValue) => {
    setValue(newValue);
    setFlag(flag[newValue]);
    getAllBookingDetailBySearchCriteria({
      token: token.token,
      payload: { offset: rowsPerPage, page: page, flag: flag[newValue] },
    });
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = bookingSpaces.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = async (event, newPage) => {
    setPage(newPage);
    await getAllBookingDetailBySearchCriteria({
      token: token.token,
      payload: { offset: rowsPerPage, page: newPage, flag: getFlag },
    });
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    getAllBookingDetailBySearchCriteria({
      token: token.token,
      payload: { offset: parseInt(event.target.value, 10), page: 0, flag: getFlag },
    });
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
    getAllBookingDetailBySearchCriteria({
      token: token.token,
      payload: {
        offset: rowsPerPage,
        page: page,
        flag: getFlag,
        customerName: event.target.value,
      },
    });
  };

  // pos code start
  const handleStartPayment = (values) => {
    handleCloseModal();
    startPayment({
      token: token.token,
      payload: {
        amount: rowData.totalAmount,
        appKey: '252488f7-42d5-4830-bffc-a75e54214807',
        customerEmail: rowData.customerDetailResponseDTO.email,
        customerMobileNumber: rowData.customerDetailResponseDTO.phoneNo,
        customerName: rowData.customerDetailResponseDTO.name,
        externalRefNumber: rowData.bookingCode,
        mode: 'ALL',
        pushTo: { deviceId: `${values.posDevice}|ezetap_android` },
        username: '3939000201',
      },
    });
  };

  function handleCheckStatus() {
    console.log('In check status');
    checkStatus({
      token: token.token,
      requestId: startPaymentResponse?.data?.p2pRequestId,
    });
  }

  useEffect(() => {
    if (startPaymentResponse?.data?.success === true) {
      const intervalID = setInterval(handleCheckStatus, 5000);
      setId(intervalID);
    }
    if (startPaymentResponse?.data?.success === false) {
      const errorData: any = startPaymentResponse?.data?.errorMessage;
      toast.error('Something went wrong. ' + errorData);
    }
    // return () => clearInterval(id);
  }, [startPaymentResponse?.data]);

  useEffect(() => {
    if (
      checkStatusResponse?.data?.success === true &&
      checkStatusResponse?.data?.messageCode == 'P2P_DEVICE_TXN_DONE'
    ) {
      setTraxnId(checkStatusResponse?.data?.txnId);
      setMessageCode(checkStatusResponse?.data?.messageCode);
      if (messageCode !== checkStatusResponse?.data?.messageCode) {
        toast.success('Transaction successfully done on POS Device.');
      }
      handlePayment(rowData);
      clearInterval(id);
      setId(0);
    } else if (
      checkStatusResponse?.data?.errorMessage ==
      'You have already made a similar payment for the same Ref# null and amount {1}. Please check the status of the payment(s) made before you proceed.' &&
      checkStatusResponse?.data?.status === 'FAILED' &&
      checkStatusResponse?.data?.success === false
    ) {
      setMessageCode(checkStatusResponse?.data?.messageCode);
      if (messageCode !== checkStatusResponse?.data?.messageCode) {
        toast.success(
          'You have already made a similar payment for the same request and amount. Please check the status of the payment(s) made before you proceed.'
        );
      }
      clearInterval(id);
      setId(0);
    } else if (
      checkStatusResponse?.data?.success === true &&
      checkStatusResponse?.data?.messageCode == 'P2P_STATUS_QUEUED'
    ) {
      setMessageCode(checkStatusResponse?.data?.messageCode);
      if (messageCode !== checkStatusResponse?.data?.messageCode) toast.success('Request queued please wait.');
    } else if (
      checkStatusResponse?.data?.success === true &&
      checkStatusResponse?.data?.messageCode == 'P2P_DEVICE_RECEIVED'
    ) {
      setMessageCode(checkStatusResponse?.data?.messageCode);
      if (messageCode !== checkStatusResponse?.data?.messageCode)
        toast.success('Notification has been received on POS Device. Please wait.');
    } else if (
      checkStatusResponse?.data?.success === true &&
      checkStatusResponse?.data?.messageCode == 'P2P_DEVICE_CANCELED'
    ) {
      setMessageCode(checkStatusResponse?.data?.messageCode);
      if (messageCode !== checkStatusResponse?.data?.messageCode) {
        toast.error('Transaction has been canceled on POS Device.');
      }
      clearInterval(id);
      setId(0);
    } else if (checkStatusResponse?.data?.success === false) {
      setMessageCode(checkStatusResponse?.data?.errorData);
      const errorData: any = checkStatusResponse?.data?.errorMessage;
      if (messageCode !== checkStatusResponse?.data?.errorData) {
        toast.error('Something went wrong ' + errorData);
      }
      clearInterval(id);
      setId(0);
    }
    // return () => clearInterval(id);
  }, [checkStatusResponse?.data, messageCode]);

  const handlePayment = (rowData: any) => {
    updateBookingDetail({
      token: token.token,
      payload: {
        bookingAmount: rowData.bookingAmount,
        bookingCode: rowData.bookingCode,
        bookingDate: rowData.bookingDate,
        bookingStatus: rowData.bookingStatus,
        cardAmount: rowData.cardAmount,
        cartId: rowData.cartId,
        checkinTime: rowData.checkinTime,
        checkoutTime: rowData.checkoutTime,
        convenienceFee: rowData.convenienceFee,
        countyTax: rowData.countyTax,
        customerId: rowData.customerId,
        // customerVehicleDetailResDTO: {
        //   customerId: rowData.customerVehicleDetailResDTO.customerId,
        //   id: rowData.customerVehicleDetailResDTO.id,
        //   isCommercial: rowData.customerVehicleDetailResDTO.isCommercial,
        //   isPrimary: rowData.customerVehicleDetailResDTO.isPrimary,
        //   makerName: rowData.customerVehicleDetailResDTO.makerName,
        //   modelNumber: rowData.customerVehicleDetailResDTO.modelNumber,
        //   status: rowData.customerVehicleDetailResDTO.status,
        //   vehicleCategory: rowData.customerVehicleDetailResDTO.vehicleCategory,
        //   vehicleNumber: rowData.customerVehicleDetailResDTO.vehicleNumber,
        // },
        disputeResolutionDate: rowData.disputeResolutionDate,
        email: rowData.customerDetailResponseDTO.email,
        // extraAmount: rowData.extraAmount,
        // extraAmtTransId: rowData.extraAmtTransId,
        fixedFee: rowData.fixedFee,
        id: rowData.id,
        // invoiceDate: rowData.invoiceDate,
        invoiceType: 'POS',
        isDisputed: rowData.isDisputed,
        isGuest: rowData.isGuest,
        isParked: rowData.isParked,
        isVendorPaid: rowData.isVendorPaid,
        // offerDetailId: rowData.offerDetailId,
        paidBy: rowData.paidBy,
        parkingCategoryId: rowData.parkingCategoryId,
        parkingLocationId: rowData.parkingLocationId,
        parkingSlotId: rowData.parkingSlotId,
        // paymentMethodId: rowData.paymentMethodId,
        paymentStatus: 'Completed',
        phoneNo: rowData.customerDetailResponseDTO.phoneNo,
        // qrImage: rowData.qrImage,
        rewardGained: rowData.rewardGained,
        rewardUsed: rowData.rewardUsed,
        salesTax: rowData.salesTax,
        serviceProviderId: rowData.serviceProviderId,
        stateTax: rowData.stateTax,
        status: rowData.status,
        subBookingId: rowData.subBookingDetailList[0].id,
        taxAmount: rowData.taxAmount,
        totalAmount: rowData.totalAmount,
        transactionRefId: traxnId,
        uniqueBookingId: rowData.uniqueBookingId,
        userTimezone: rowData.userTimezone,
        vehicleNumber: rowData.vehicleNumber,
      },
    });
  };

  useEffect(() => {
    if (updateBookingDetailResponse.isSuccess) {
      setTimeout(() => {
        toast.success('Payment completed!');
      }, 3000);
      getAllBookingDetailBySearchCriteria({
        token: token.token,
        payload: { offset: rowsPerPage, page: page, flag: getFlag },
      });

    } else if (updateBookingDetailResponse.isError) {
      const errorData: any = updateBookingDetailResponse.error;
      const msg: any = errorData.data.serviceErrors[0].msg;
      toast.error('Something went wrong ' + msg || '');
    }
  }, [updateBookingDetailResponse.isSuccess, updateBookingDetailResponse.isError]);

  // pos code start

  const handleAddDriver = () => {
    handleOpenModal();
  };

  return (
    <Page title="Booking Overview">
      {checkPermissions(PERMISSION.BOOKING_ALL, token.permissions) ||
        checkPermissions(PERMISSION.BOOKING_ALL_ENCRYPT, token.permissions) ? (
        <Container>
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Typography variant="h4" gutterBottom>
              Booking Overview
            </Typography>
            {checkPermissions(PERMISSION.BOOKING_ALL_ENCRYPT, token.permissions) ? null : (
              <Button
                style={{
                  marginRight: '10px',
                  color: 'white',
                  backgroundColor: '#E23744',
                }}
                size="large"
                variant="contained"
                onClick={() => {
                  navigate('/dashboard/all-cancellations');
                }}
              >
                All Cancellations ({cancelRequestCount})
              </Button>
            )}
          </Stack>
          <Stack direction="row" alignItems="center" justifyContent="flex-start" mb={5}>
            <Tabs value={value} onChange={handleChange} aria-label="nav tabs example">
              <LinkTab className="tab" label="Current Bookings" />
              <LinkTab className="tab" label="Past Bookings" />
              <LinkTab className="tab" label="Cancelled Bookings" />
            </Tabs>
          </Stack>
          <Card>
            <BookingListToolbar
              numSelected={selected.length}
              filterName={filterName}
              onFilterName={handleFilterByName}
              placeholder={'Search By Customer Name'}
            />
            <Scrollbar>
              <TableContainer sx={{ minWidth: 800 }}>
                <Table>
                  <BookingListHead
                    order={order}
                    orderBy={orderBy}
                    headLabel={getFlag == 'CANCEL_BOOKING' ? TABLE_HEAD_CANCELBOOKING : TABLE_HEAD}
                    rowCount={bookingSpaces.length}
                    numSelected={selected.length}
                    onRequestSort={handleRequestSort}
                    onSelectAllClick={handleSelectAllClick}
                  />
                  <TableBody>
                    {filteredUsers.length > 0 &&
                      filteredUsers.map((row) => {
                        const {
                          id,
                          parkingSlotRespDTO,
                          paymentStatus,
                          bookingCode,
                          transactionRefId,
                          bookingDate,
                          bookingAmount,
                          checkinTime,
                          checkoutTime,
                          customerDetailResponseDTO,
                          parkingSpaceLocationRespDTO,
                          serviceProviderDetailResponseDTO,
                          bookingStatus,
                          cancellationReasonName,
                          parkingCategoryResDTO,
                          subBookingDetailList,
                          taxAmount,
                          rewardUsed,
                          rewardGained,
                          convenienceFee,
                          actualCheckinTime,
                          actualCheckoutTime,
                          totalAmount,
                          countyTax,
                          salesTax,
                          stateTax,
                          fixedFee,
                          paidBy,
                          fromLocation,
                          toLocation
                        } = row;
                        // const isItemSelected = selected.indexOf(itemName) !== -1;

                        return (
                          <>
                            <TableRow
                              hover
                              key={`${id + '-' + getUniqueKey() + 'allBookingId'}`}
                              tabIndex={-1}
                            // selected={isItemSelected}
                            // aria-checked={isItemSelected}
                            >
                              <TableCell align="left">
                                <Typography
                                  fontWeight="semibold"
                                  variant="subtitle2"
                                  style={{
                                    color: checkPermissions(PERMISSION.BOOKING_ALL_ENCRYPT, token.permissions)
                                      ? 'grey'
                                      : 'blue',
                                    cursor: checkPermissions(PERMISSION.BOOKING_ALL_ENCRYPT, token.permissions)
                                      ? 'cursor-text'
                                      : 'pointer',
                                  }}
                                  onClick={() => {
                                    if (!checkPermissions(PERMISSION.BOOKING_ALL_ENCRYPT, token.permissions)) {
                                      navigate('/dashboard/booking-details', {
                                        state: {
                                          id: id,
                                          getFlag:getFlag,
                                          parkingSlotRespDTO: parkingSlotRespDTO,
                                          paymentStatus: paymentStatus,
                                          bookingCode: bookingCode,
                                          transactionRefId: transactionRefId,
                                          actualCheckinTime: actualCheckinTime,
                                          actualCheckoutTime: actualCheckoutTime,
                                          bookingDate: bookingDate,
                                          bookingAmount: bookingAmount,
                                          checkinTime: checkinTime,
                                          checkoutTime: checkoutTime,
                                          customerDetailResponseDTO: customerDetailResponseDTO,
                                          parkingSpaceLocationRespDTO: parkingSpaceLocationRespDTO,
                                          serviceProviderDetailResponseDTO: serviceProviderDetailResponseDTO,
                                          bookingStatus: bookingStatus,
                                          taxAmount: taxAmount,
                                          rewardUsed: rewardUsed,
                                          rewardGained: rewardGained,
                                          convenienceFee: convenienceFee,
                                          totalAmount: totalAmount,
                                          cancellationReasonName: cancellationReasonName,
                                          countyTax: countyTax,
                                          salesTax: salesTax,
                                          stateTax: stateTax,
                                          fixedFee: fixedFee,
                                        },
                                      });
                                    }
                                  }}
                                  align="left"
                                >
                                  {bookingCode}
                                </Typography>
                              </TableCell>
                              <TableCell align="left">{customerDetailResponseDTO?.name}</TableCell>
                              <TableCell align="left">
                                {parkingSpaceLocationRespDTO?.serviceProviderDetailResponseDTO?.vendorAlias}
                              </TableCell>
                              {/* <TableCell align="left">{parkingSpaceLocationRespDTO?.name}</TableCell> */}
                              <TableCell align="left">₹{totalAmount?.toFixed(2)}</TableCell>
                              {/* {getFlag !== 'CANCEL_BOOKING' ? (
                                <TableCell align="left">
                                  {parkingCategoryResDTO?.subCategoryName !== null
                                    ? parkingCategoryResDTO?.subCategoryName
                                    : 'NA'}
                                </TableCell>
                              ) : null} */}
                              <TableCell align="left">{fDateTimeSuffix(bookingDate)}</TableCell>

                              {getFlag !== 'CANCEL_BOOKING' ? (
                                <TableCell align="left">
                                  {fDateTimeSuffix(checkinTime)}
                                </TableCell>
                              ) : (
                                ''
                              )}
                              {getFlag !== 'CANCEL_BOOKING' ? (
                                <TableCell align="left">
                                  {fDateTimeSuffix(checkoutTime)}
                                </TableCell>
                              ) : null}
                              {getFlag !== 'CANCEL_BOOKING' ? (
                                <Tooltip
                                  title={fromLocation}
                                  placement="bottom-end"
                                  className="text-center"
                                >
                                  <TableCell
                                    align="center"
                                    style={{
                                      maxWidth: '150px', 
                                      overflow: 'hidden', 
                                      textOverflow: 'ellipsis', 
                                      whiteSpace: 'nowrap', 
                                    }}
                                  >
                                    {fromLocation}
                                  </TableCell>
                                </Tooltip>
                              ) : null}
                              {getFlag !== 'CANCEL_BOOKING' ? (
                                <Tooltip
                                  title={toLocation}
                                  placement="bottom-end"
                                  className="text-center"
                                >
                                  <TableCell
                                    align="center"
                                    style={{
                                      maxWidth: '150px', 
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis', 
                                      whiteSpace: 'nowrap',
                                    }}
                                  >
                                    {toLocation}
                                  </TableCell>
                                </Tooltip>
                              ) : null}


                              <TableCell
                                align="left"
                                style={{
                                  fontWeight: 'bold',
                                  ...(timeInMiliseconds(actualCheckinTime, actualCheckoutTime, bookingStatus) >
                                    7200000 &&
                                    actualCheckinTime !== null &&
                                    actualCheckoutTime == null &&
                                    bookingStatus == 'booked'
                                    ? checkInStatusStyle
                                    : bookingStatus == 'Completed' || bookingStatus == 'Checkout'
                                      ? completedStatusStyle
                                      : bookingStatus == 'Checkout'
                                        ? checkoutStatusStyle
                                        : ''),
                                }}
                              >
                                {toUpper(
                                  actualCheckinTime !== null && actualCheckoutTime == null && bookingStatus == 'booked'
                                    ? 'Checkin'
                                    : bookingStatus
                                )}
                              </TableCell>
                             {/** {getFlag !== 'CANCEL_BOOKING' ? (
                                <TableCell> <Tooltip title="Add Driver">
                                <IconButton
                                  onClick={() => handleAddDriver()}
                                  style={{ color: '#E23744' }}
                                >
                                  <PersonAddIcon/>
                                </IconButton>
                              </Tooltip></TableCell>
                              ) : null} */}
                              

                              {getFlag == 'CANCEL_BOOKING' ? (
                                <TableCell align="left">{cancellationReasonName}</TableCell>
                              ) : null}
                            </TableRow>
                          </>
                        );
                      })}
                  </TableBody>
                  {isUserNotFound && (
                    <TableBody>
                      <TableRow>
                        <TableCell align="center" colSpan={12} sx={{ py: 3 }}>
                          <SearchNotFound searchQuery={filterName} />
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Scrollbar>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={bookingTotalRecords || 0}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Card>
        </Container>
      ) : null}
      {getAllBookingResponse.isLoading || getAllCancellationResponse.isLoading ? <Loading /> : null}
    </Page>
  );
}
